/* eslint-disable no-use-before-define */
import axios from 'axios'
import { prefixUrl, mutateKeys_lowercaseFirstLetter } from 'utils'

export const types = {
  GET_PROFILE: 'user.GET_PROFILE',
}

const SERVICE_ENDPOINT = prefixUrl('/Services/Profile.ashx')

export const getProfile = () => {
  return {
    type: types.GET_PROFILE,
    payload: axios.get(SERVICE_ENDPOINT)
      .then(response => {
        const { Success } = response.data
        if(typeof Success !== 'undefined' && !Success) {
          return undefined
        }
        return {
          profile: mutateKeys_lowercaseFirstLetter(response.data.Payload.Profile),
          learningStats: mutateKeys_lowercaseFirstLetter(response.data.Payload.HomepageStats),
        }
      })
  }
}
